import { useEffect, useState } from 'react'
import throttle from '../lib/throttle'

const TABLET_BREAKPOINT = 1280
const MOBILE_BREAKPOINT = 504

function useMenuBreakpoint() {
  const [isTablet, setIsTablet] = useState(undefined)
  const [isMobile, setIsMobile] = useState(undefined)

  const handleResize = throttle(() => {
    const width = window.innerWidth
    setIsTablet(width < TABLET_BREAKPOINT)
    setIsMobile(width < MOBILE_BREAKPOINT)
  }, 100)

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    handleResize()
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return [isMobile, isTablet]
}

export default useMenuBreakpoint
